export default __webpack_public_path__ + "static/media/CrossGrey.51cb2b5b.svg";